import { TApiBodyObject, TBaseDataObject } from '../../store/saga/api/types';
import { extractFiles } from './extractFiles';
import { TConstructFdBodyResult } from './types';

export const constructFdBody = (bodyObj: TApiBodyObject): TConstructFdBodyResult => {
  const {cleaned, files} = extractFiles(bodyObj.data);

  return {
    data: cleaned as TBaseDataObject | TBaseDataObject[],
    meta: bodyObj.meta,
    files
  }
};
